<template>
    <div>
        <section class="folders-section section py-5 px-5">
            <div class="columns is-mobile">
                <div class="column">
                    <p class="px-3 is-size-4 has-text-black">
                        <span class="">{{$t('app_list_projects')}}</span>
                    </p>
                    <p class="px-3 is-size-6 has-text-eduloc-grey secondary-font">
                        <span class="">{{$t('app_list_projects_description')}}</span>
                    </p>
                </div>
                <div class="column is-narrow has-text-centered" v-if="entityCode">
                    <figure class="image is-96x96 mt-2" style="margin:0 auto;" >
                        <vue-qrcode ref="qrcode" :value="qrUrl" :margin="0"/>
                    </figure>
                    <div class="pt-2">
                        <p class="has-text-eduloc-red is-size-5 beton-font">{{ entityCode }}</p>
                    </div>
                    <div class="" v-if="canChangeCode">
                        <button @click="showChangeCodeModal=true" class="button is-primary is-fullwidth has-text-weight-bold is-small">{{ $t('change_user_code') }}</button>
                    </div>
                </div>
            </div>
            
        </section>
        <section ref="searchBox" class="section pt-5 px-5 pb-6">
                <!--<hr v-if="selectedFilter == 'mine'" />-->
                <div class="mx-3">
                    <dashboard-app-content-search
                        v-model="textSearch"
                        @change-filter="changeFilter"
                        @change-project-type="changeProjectType"
                        @change-order="changeOrder"
                        @change-switch-mode="changeMode"
                        :default-switch-mode-name="'LIST_MODE'"
                        :loading="loading"
                        :switch-mode="true"
                        class=""
                    />
                </div>
            </section>
        <section class="section pt-0 px-5 pb-6">

            <dashboard-app-content-list 
                v-if="filteredProjects.length"
                :projects="filteredProjects"
                :showCreationCard="false" 
                :showMode="showMode"
                @toggleListed="toggleListed" 
                :showAppContentStatus="true"
            />
            <p
                v-else-if="!loading"
                v-t="'no_content_to_show'"
                class="notification is-eduloc-yellow mx-3"
            ></p>
        </section>
        <app-modal-view  class="change-code-modal" v-if="showChangeCodeModal">

        <template #body>
            <div class="field">
                <label for="user-code" class="label">{{ $t('new_user_code') }}</label>
                <div class="control has-icons-right">
                    <input name="user-code" class="input eduloc" type="text" v-model="newUserCode" :class="showCodeError?'is-danger':''" @change="checkCodeField" style="text-transform: uppercase;"> 
                    <span class="icon is-small is-right" v-if="showCodeError">
                        <i class="fas fa-exclamation-triangle has-text-danger"></i>
                    </span>
                </div>
                <p class="help is-danger is-size-7" v-if="showCodeError">{{ $t('user_code_error_text') }}</p>
            </div>
            <nav class="level pt-5">
                <div class="level-left">
                    <div class="level-item">
                        <p class="control">
                            <button class="button is-primary" @click="checkForm">{{ $t('save') }}</button>
                        </p>
                    </div>
                </div>
                <div class="level-right">
                    <p class="control">
                        <button class="button" @click="showChangeCodeModal=false">{{ $t('cancel') }}</button>
                    </p>
                </div>
            </nav>
        </template>
    </app-modal-view>
    </div>
</template>

<script>
import { fetchAppContent, checkAppListCode, updateMyAppListCode } from '@/services/API';
import DashboardAppContentList from '@/components/DashboardAppContentList';
import DashboardAppContentSearch from '@/components/DashboardAppContentSearch';
import NProjectSearchBarWithFilter from '@/components/NProjectSearchBarWithFilter';
import _ from 'underscore';
import { Document } from 'flexsearch';
import VueQrcode from 'vue-qrcode';
import AppModalView from '@/components/AppModalView';

export default {
    components: {
        DashboardAppContentList,
        DashboardAppContentSearch,
        NProjectSearchBarWithFilter,
        VueQrcode,
        AppModalView,
    },
    props: {},
    data() {
        return {
            content: [],
            loading: false,
            textSearch: "",
            typeSearch: 'PROJECT_TYPE_ALL',
            filterSearch: 'APP_ALL',
            order: 'CREATED_ASC',
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        {
                            field: 'title',
                            minlength: 0,
                        },
                        'owner:name',
                        'owner:email',
                    ],
                },
            }),
            contentToShow: [],
            showMode: 'LIST_MODE',
            showChangeCodeModal: false,
            newUserCode: this.$store.getters.user && this.$store.getters.user.appListCode ? this.$store.getters.user.appListCode : "",
            showCodeError: false,
            baseURL: process.env.VUE_APP_WWW_URL
        };
    },
    mounted() {
        this.loading = true;
        fetchAppContent().then(({ data }) => {
            this.content = data;
            this.loading = false;
        });
    },
    watch: {
        content: {
            handler: function () {

                // console.log("change content")
                this.content.forEach((item) => {
                    // console.log;
                    this.searchIndex.add(item);
                });
                //console.log("change in items")
                //this.searchIndex.add(this.items)
            },
            immediate: true,
            deep: true,
        },
        

    },
    computed: {
        entityCode() {
            // console.log(this.$store.getters.user)
            if (this.$store.getters.school && this.$store.getters.school.shortCode) {
                // console.log("returning school shortcode")
                return this.$store.getters.school.shortCode
            } else {
                // console.log("returning user shortcode")
                return this.$store.getters.user.appListCode
            }
            
        },
        canChangeCode() {
            return !this.$store.getters.school || (this.$store.getters.school && !this.$store.getters.school.shortCode)
        },
        textFilteredProjects() {
            // console.log("textSearch",this.textSearch)
            if (this.textSearch) {
                this.rebuildIndex();
                this.content.forEach((item) => {
                    this.searchIndex.add(item);
                });
                const result = this.searchIndex.search(this.textSearch);
                // console.log(this.textSearch, result);
                const ids = _.chain(result).pluck('result').flatten().value();
                // console.log('ids', ids);
                return this.content.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }
            return this.content;
        },
        filteredProjects() {
            // console.log("filtering projects")
            let projects = this.textFilteredProjects;
            let inFilters = [];
            let inType = [];

            if(this.typeSearch){
                if(this.typeSearch!='PROJECT_TYPE_ALL'){
                    inType =
                        _.filter(
                            this.textFilteredProjects,
                            (project) => {
                                if (project.project) {
                                    return project.project.format == this.typeSearch
                                } else {
                                    return project.format == this.typeSearch
                                }
                            }
                        );
                }else{
                    inType = projects;
                }
                
            }

            if (inType.length) {
                projects = _.uniq(_.intersection(projects, inType));
            }else{
                projects = [];
            }


            if(this.filterSearch){
                if(this.filterSearch!='APP_ALL'){
                    inFilters =
                        _.filter(
                            this.textFilteredProjects,
                            (project) => {
                                return ((this.filterSearch == 'APP_LISTED' && project.showInAppList) || (this.filterSearch == 'APP_UNLISTED' && !project.showInAppList))
                            }
                        );
                }else{
                    inFilters = projects;
                }
                
            }

            if (inFilters.length) {
                projects = _.uniq(_.intersection(projects, inFilters));
            }else{
                projects = [];
            }

            if(this.order){
                let orderedProjects;
                // console.log('ordening',this.order)
                switch(this.order){
                    case 'CREATED_DESC':
                        orderedProjects = _.sortBy(projects, function(o) { 
                            return o.created; 
                            });
                        break;
                    case 'CREATED_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.created; }).reverse();
                        break;
                    case 'MODIFIED_DESC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.modified; });
                        break;
                    case 'MODIFIED_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.modified; }).reverse();
                        break;
                    case 'TITLE_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.title; });
                        break;
                    case 'AUTHOR_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.owner.username; });
                        break;
                    default: 
                        orderedProjects = _.sortBy(projects, function(o) { return o.created; }).reverse();
                        break;
                }
                projects = orderedProjects;
            }
            return projects;
        },
        qrUrl() {
            console.log(encodeURI(this.baseURL + '/goapp.html?code=' + this.entityCode));
            return encodeURI(this.baseURL + '/goapp.html?code=' + this.entityCode);
        }
        
    },
    methods: {
        toggleListed(project) {
            //this.$emit("toggleHighlight",project)
            const updatedIndex = _.findIndex(this.content, {
                _id: project._id,
            });

            this.content.splice(updatedIndex, 1, project);
        },
        changeFilter(e){
            // console.log("change filter",e)
            this.filterSearch=e;
        },
        changeProjectType(e){
            // console.log("change project type",e)
            this.typeSearch=e;
        },
        changeOrder(e){
            // console.log("change order",e)
            this.order=e;
        },
        rebuildIndex() {
            let projects = this.content;
            this.searchIndex.remove(projects);
        },
        changeMode(e) {
            // console.log("change show mode",e)
            this.showMode = e;
        },
        async checkCodeField() {
            this.showCodeError = false;
            //console.log("checking",this.newUserCode)
            const regex = /^[A-Z0-9]{10,}$/;  // Mínim 10 caràcters, només A-Z i 0-9

            if (!regex.test(this.newUserCode.toUpperCase())) {
                this.showCodeError = true;
                console.log("error")
                return;
            }

            await checkAppListCode({ 'appListCode': this.newUserCode.toUpperCase() })
            .catch((e) => {
                console.log('error on check app list code ', e.data)
                this.showCodeError = true;
                return;
            })
            .then((response) => {
                if (response && response.status == 200) {
                        this.showCodeError = false;
                    return;
                }
            })
             
            //console.log("code pass",this.showCodeError)
        },
        async checkForm() {
            this.checkCodeField();
            if (this.showCodeError) {
                return;
            }
            // console.log("'sending'")
            await updateMyAppListCode({ 'appListCode': this.newUserCode.toUpperCase() })
            .catch((e) => {
                console.log('error on update app list code ', e.data)
                this.showCodeError = true;
                return;
            })
            .then((response) => {
                if (response && response.status == 200) {
                    this.showCodeError = false;
                    this.showChangeCodeModal = false;
                    this.$store.dispatch('fetchProfile');
                    return;
                }
            })

        }
        
    },
};
</script>

<style scooped>
    .button.is-small{
        height: 2rem;
    }
    .change-code-modal .modal-card-head{
        padding: 0;
    }
    .change-code-modal label{
        color:#000000;
    }
</style>
